import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProfileService } from 'src/app/api/profile.service';
import { BankDetails } from 'src/app/models/bank-details';

@Component({
  selector: 'citizenship-residency-validation-ticket',
  templateUrl: './citizenship-residency-validation-ticket.component.html',
  styleUrls: ['./citizenship-residency-validation-ticket.component.scss']
})
export class CitizenshipResidencyValidationTicketComponent implements OnInit {
  @Input() form: FormGroup;

  bankDetails: BankDetails;

  constructor() { }

  ngOnInit() {
  }

  onFileSelect(file) {
    this.form.get('citizenshipResidencyValidation.passport').setValue({
      name: file.file.name,
      content: file.base64
    });
  }

  onFileRemove() {
    this.form.get('citizenshipResidencyValidation.passport').reset();
  }

}
